// src/App.js
import React, { useState, useEffect, useCallback } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";

// Importaciones de componentes
import UserWelcome from "./pages/UserWelcome";
import Importar from "./pages/Importar";
import Informes from "./pages/Informes";
import Informe30Dias from "./pages/Informe30Dias"; // ← NUEVO
import InteligenciaArtificial from "./pages/InteligenciaArtificial";
import Graficos from "./pages/Graficos";
import Tendencias from "./pages/Tendencias";
import Telegram from "./pages/Telegram";
import Transportadora from "./pages/Transportadora"; // ← NUEVO
import Login from "./pages/Login";
import ProtectedRoute from "./components/ProtectedRoute";

// NUEVO: protección por rol
import ProtectedRouteByRole from "./components/ProtectedRouteByRole";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [checkingAuth, setCheckingAuth] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const token = localStorage.getItem("token");
    setIsAuthenticated(!!token);
    setCheckingAuth(false);
  }, []);

  const handleLoginSuccess = (token) => {
    localStorage.setItem("token", token);
    setIsAuthenticated(true);
  };

  const handleLogout = useCallback(() => {
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    localStorage.removeItem("username");
    setIsAuthenticated(false);
  }, []);

  // Timeout de inactividad: 15 min
  const INACTIVITY_TIMEOUT = 15 * 60 * 1000;
  useEffect(() => {
    let inactivityTimer;
    const resetTimer = () => {
      clearTimeout(inactivityTimer);
      inactivityTimer = setTimeout(handleLogout, INACTIVITY_TIMEOUT);
    };
    window.addEventListener("mousemove", resetTimer);
    window.addEventListener("keydown", resetTimer);
    resetTimer();
    return () => {
      window.removeEventListener("mousemove", resetTimer);
      window.removeEventListener("keydown", resetTimer);
      clearTimeout(inactivityTimer);
    };
  }, [handleLogout]);

  if (checkingAuth) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
        <p>Cargando...</p>
      </div>
    );
  }

  return (
    <Routes>
      <Route
        path="/login"
        element={
          isAuthenticated ? (
            <Navigate to="/informes" replace />
          ) : (
            <Login onLoginSuccess={handleLoginSuccess} />
          )
        }
      />

      <Route
        path="/"
        element={
          <ProtectedRoute isAuthenticated={isAuthenticated}>
            <UserWelcome onLogout={handleLogout} />
          </ProtectedRoute>
        }
      >
        {/* Módulos NO visibles para 'transportadora' */}
        <Route
          path="importar"
          element={
            <ProtectedRouteByRole allowedRoles={["admin", "user"]}>
              <Importar />
            </ProtectedRouteByRole>
          }
        />
        <Route
          path="informes"
          element={
            <ProtectedRouteByRole allowedRoles={["admin", "user"]}>
              <Informes />
            </ProtectedRouteByRole>
          }
        />
        <Route
          path="informe-30dias"
          element={
            <ProtectedRouteByRole allowedRoles={["admin", "user"]}>
              <Informe30Dias />
            </ProtectedRouteByRole>
          }
        />
        <Route
          path="inteligencia-artificial"
          element={
            <ProtectedRouteByRole allowedRoles={["admin", "user"]}>
              <InteligenciaArtificial />
            </ProtectedRouteByRole>
          }
        />
        <Route
          path="graficos"
          element={
            <ProtectedRouteByRole allowedRoles={["admin", "user"]}>
              <Graficos />
            </ProtectedRouteByRole>
          }
        />
        <Route
          path="tendencias"
          element={
            <ProtectedRouteByRole allowedRoles={["admin", "user"]}>
              <Tendencias />
            </ProtectedRouteByRole>
          }
        />
        <Route
          path="telegram"
          element={
            <ProtectedRouteByRole allowedRoles={["admin", "user"]}>
              <Telegram />
            </ProtectedRouteByRole>
          }
        />

        {/* Módulo SOLO para admin y transportadora */}
        <Route
          path="transportadora"
          element={
            <ProtectedRouteByRole allowedRoles={["admin", "transportadora"]}>
              <Transportadora />
            </ProtectedRouteByRole>
          }
        />

        {/* Redirección por defecto según rol */}
        <Route
          index
          element={
            (() => {
              const role = localStorage.getItem("role");
              if (role === "transportadora") return <Navigate to="/transportadora" replace />;
              return <Navigate to="/informes" replace />;
            })()
          }
        />
      </Route>

      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}

export default App;
